import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { NgSwitch } from '@angular/common';
import { ActivatedRoute, Router, Routes, RouterModule } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-singlecategory',
  templateUrl: './single-category.component.html',
  styleUrls: ['./single-category.component.scss']
})
export class SinglecategoryComponent {
  tagID: string;
  viewMode = 'tab1';
  constructor(public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute, public http: HttpClient, private router: Router) { this.ping() }
  channel:any;
  tag:any;
siteID = environment.siteID;
isHeadStart = environment.isHeadStart;
  myData : any;
  playlists: any;
  contents: any;
  playlist: any;
  public ping() {
    this.route.params.subscribe(params2 => {
      this.tagID = params2['tagID'];
     
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      this.http.get('https://api-staging.videyo.tv/endpoint/getChannelsByTag?siteID='+this.siteID+'&tagID='+this.tagID, {
        headers: myheader
      })
      .subscribe(
        data => {
          this.tag = data['tag'];
          this.channel = data['channel'];
          this.playlists = [] // reset to empty list.
          this.contents = [] // reset to empty list.
          this.channel.forEach(channel => {
             // now with this channel, do the same for each playlist.
             channel.playlists.forEach(playlist => {
                 this.playlists.push(playlist) // add playlist to this.playlist.
               
                 // then, for each playlist, let’s get a hold of each item of
                 // content and add it to the total list of content...
                 playlist.contents.forEach( content => {
                   this.contents.push(content) // add it to the array.
                 });
             });
          });
        },
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('myModal1', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
      );
      });
}
refresh(): void {
  window.location.reload();
}

}
